var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gw-page-intro"},[_c('div',{staticClass:"gw-page-intro__meta"},[_vm._t("meta")],2),_vm._v(" "),_c('div',{staticClass:"gw-page-intro__lead"},[_vm._t("lead")],2),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }